import { observable } from 'mobx';

export type FareOptionArgs = {
  option_type: 'corporate';
  qualifier: string;
  identity: string;
};

export default class FareOption {
  @observable optionType: 'corporate';
  @observable qualifier: string;
  @observable identity: string;

  constructor(args: FareOptionArgs) {
    this.optionType = args.option_type;
    this.qualifier = args.qualifier;
    this.identity = args.identity;
  }
}
